import { useQuery } from "@tanstack/react-query";
import { fetchTaskCounts, type TaskCounts } from "@tasks/tasksClient";
import { tasksKeys } from "@tasks/tasksQueries";

export const openTodoCount = (counts: TaskCounts): number =>
  Object.values(counts.byKind).reduce((n, c) => n + c.open, 0);

export const useOpenTodoCount = (sessionKey: string): number => {
  const { data } = useQuery({
    queryKey: tasksKeys.counts(sessionKey),
    queryFn: () => fetchTaskCounts(),
    select: openTodoCount,
  });
  return data ?? 0;
};
